import type { ProcessProject } from "./project-process-callbacks";

export interface SavedProcess extends ProcessProject {
    jobId: string;
    processName: string;
}

const storageKey = (userId: string) => `baamer:processes:${userId}`;

const isSavedProcess = (value: unknown): value is SavedProcess => {
    if (!value || typeof value !== "object") return false;
    const item = value as Partial<SavedProcess>;
    return typeof item.projectId === "string" && typeof item.jobId === "string"
        && typeof item.processName === "string" && typeof item.baamerRevisionId === "string"
        && typeof item.projectBoomerId === "number" && Number.isFinite(item.projectBoomerId)
        && typeof item.newBoomerRevision === "boolean";
};

export const readSavedProcesses = (userId: string): SavedProcess[] => {
    try {
        const raw = window.sessionStorage.getItem(storageKey(userId));
        const items: unknown = raw ? JSON.parse(raw) : [];
        return Array.isArray(items) ? items.filter(isSavedProcess) : [];
    } catch {
        return [];
    }
};

const writeSavedProcesses = (userId: string, processes: SavedProcess[]) => {
    try {
        if (processes.length) window.sessionStorage.setItem(storageKey(userId), JSON.stringify(processes));
        else window.sessionStorage.removeItem(storageKey(userId));
    } catch (error) {
        // Un stockage indisponible ne doit pas interrompre un job déjà lancé.
        console.error("Impossible de mémoriser le suivi du processus dans cet onglet.", error);
    }
};

export const saveProcess = (userId: string, process: SavedProcess) => {
    const others = readSavedProcesses(userId).filter(item => item.jobId !== process.jobId);
    writeSavedProcesses(userId, [...others, process]);
};

export const removeSavedProcess = (userId: string, jobId: string) => {
    writeSavedProcesses(userId, readSavedProcesses(userId).filter(item => item.jobId !== jobId));
};
